export default {
  index: [
    {
      path: '/dkspr',
      component: resolve => require(['./dksprIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/dk_spr/_router.js